module.exports = __webpack_public_path__ + "static/immdeb-a189a59e7b0485924b4e1a805c6003cd.jpg";